





//Common functions in all js imports
import './commonFunctions'


// ui Plugins
import 'owl.carousel';









// other Functions
import {mainSlider} from './js-components/mainSlider.js';
import {projectSlider} from './js-components/projectSlider.js';



jQuery( document ).ready(function() {

    mainSlider();
    projectSlider();

});
